import { MediaConstraints } from '@wui/jssip/lib/RTCSession'

import { CallMediaRequest  } from '@/shared/services/jssip'

export const parseCallMediaRequest = (string: string): CallMediaRequest => {
  const result: CallMediaRequest = {}

  const parts = string.split(';')
  parts.forEach(p => {
    const item = p.split('=')

    if (item.at(0) === 'RequestedAudio') {
      result.requestedAudio = item.at(1) === 'True'
    }

    if (item.at(0) === 'RequestedVideo') {
      result.requestedVideo = item.at(1) === 'True'
    }
  })

  return result
}

// WUI-3347: Парсинг статуса медиа участника из заголовка X-Satel-Params
// Формат: "MuteMyVideo=true;MuteMyAudio=false"
export const parseMediaConstraintsFromXSatelParams = (header: string): MediaConstraints => {
  const result: MediaConstraints = {}

  const parts = header.split(';')
  parts.forEach(p => {
    const item = p.split('=')
    const key = item.at(0)?.trim()
    const value = item.at(1)?.trim()

    if (key === 'MuteMyAudio') {
      // MuteMyAudio=true означает что аудио ВЫКЛЮЧЕНО, поэтому инвертируем
      result.audio = value !== 'true'
    }

    if (key === 'MuteMyVideo') {
      // MuteMyVideo=true означает что видео ВЫКЛЮЧЕНО, поэтому инвертируем
      result.video = value !== 'true'
    }
  })

  return result
}
